import { isStudent } from 'core/utils/user';
import { CONTENT_TYPES } from 'core/variables/constant';
import { ROUTES } from 'edelvives/utils/constants/paths';

export const notificationsTypes = {
  TODO: 'toDo',
  SOCIAL: 'social',
};

export const notificationsSubtypes = {
  SOCIAL: {
    COMMENT: 'stream-comment',
    POST: 'stream-post',
    ASSESSMENTCOMMENT: 'assessment-comment',
    JOBCOMMENT: 'job-comment',
    TENANT: 'tenant-post',
  },
  TODO: {
    ASSIGNED: 'assessment-assigned',
    REASSIGNED: 'assessment-reassigned',
    EVALUATED: 'assessment-evaluated',
    ONEDAY: 'due-date-tomorrow',
    LATE: 'due-date-today',
    DELIVERATCOMPLETE: 'teacher-deliver-at-complete',
    PUBLISHPENDING: 'teacher-publish-jobs-pending',
    STUDENTDELIVER: 'teacher-job-delivered',
    ALLDELIVER: 'teacher-all-jobs-completed',
    RESOURCE_ASSIGNED: 'resource-assigned',
    RESOURCE_EVALUATED: 'resource-evaluated',
    RESOURCE_DELIVERED: 'resource-delivered',
    RECORD_DELIVERED: 'record-delivered',
    RECORD_DELIVERED_LEMONADE: 'record-delivered-lemonade',
  },
};

export const getTypeOfSubTypeNotification = (subtypeNotification) => {
  if (
    subtypeNotification === notificationsSubtypes.TODO.ASSIGNED ||
    subtypeNotification === notificationsSubtypes.TODO.REASSIGNED ||
    subtypeNotification === notificationsSubtypes.TODO.EVALUATED ||
    subtypeNotification === notificationsSubtypes.TODO.ONEDAY ||
    subtypeNotification === notificationsSubtypes.TODO.LATE ||
    subtypeNotification === notificationsSubtypes.TODO.DELIVERATCOMPLETE ||
    subtypeNotification === notificationsSubtypes.TODO.PUBLISHPENDING ||
    subtypeNotification === notificationsSubtypes.TODO.STUDENTDELIVER ||
    subtypeNotification === notificationsSubtypes.TODO.ALLDELIVER ||
    subtypeNotification === notificationsSubtypes.TODO.RESOURCE_ASSIGNED ||
    subtypeNotification === notificationsSubtypes.TODO.RESOURCE_EVALUATED ||
    subtypeNotification === notificationsSubtypes.TODO.RESOURCE_DELIVERED ||
    subtypeNotification === notificationsSubtypes.TODO.RECORD_DELIVERED ||
    subtypeNotification === notificationsSubtypes.TODO.RECORD_DELIVERED_LEMONADE
  ) {
    return notificationsTypes.TODO;
  } else if (
    subtypeNotification === notificationsSubtypes.SOCIAL.COMMENT ||
    subtypeNotification === notificationsSubtypes.SOCIAL.POST ||
    subtypeNotification === notificationsSubtypes.SOCIAL.ASSESSMENTCOMMENT ||
    subtypeNotification === notificationsSubtypes.SOCIAL.JOBCOMMENT
  ) {
    return notificationsTypes.SOCIAL;
  }
};

export const isNotificationTypeToDo = (typeNotification) => {
  return (
    typeNotification === notificationsSubtypes.TODO.ASSIGNED ||
    typeNotification === notificationsSubtypes.TODO.REASSIGNED ||
    typeNotification === notificationsSubtypes.TODO.EVALUATED ||
    typeNotification === notificationsSubtypes.TODO.ONEDAY ||
    typeNotification === notificationsSubtypes.TODO.LATE ||
    typeNotification === notificationsSubtypes.TODO.DELIVERATCOMPLETE ||
    typeNotification === notificationsSubtypes.TODO.PUBLISHPENDING ||
    typeNotification === notificationsSubtypes.TODO.STUDENTDELIVER ||
    typeNotification === notificationsSubtypes.TODO.ALLDELIVER ||
    typeNotification === notificationsSubtypes.TODO.RESOURCE_ASSIGNED ||
    typeNotification === notificationsSubtypes.TODO.RESOURCE_EVALUATED ||
    typeNotification === notificationsSubtypes.TODO.RESOURCE_DELIVERED ||
    typeNotification === notificationsSubtypes.TODO.RECORD_DELIVERED ||
    typeNotification === notificationsSubtypes.TODO.RECORD_DELIVERED_LEMONADE
  );
};

export const isNotificationTypeSocial = (typeNotification) => {
  return (
    typeNotification === notificationsSubtypes.SOCIAL.COMMENT ||
    typeNotification === notificationsSubtypes.SOCIAL.POST ||
    typeNotification === notificationsSubtypes.SOCIAL.ASSESSMENTCOMMENT ||
    typeNotification === notificationsSubtypes.SOCIAL.JOBCOMMENT
  );
};

export function isResourceNotification(typeNotification) {
  return typeNotification.includes('resource');
}

export function getRouteToClickInNotification(notification, user) {
  if (isNotificationTypeSocial(notification.type)) {
    return getSocialNotificationsRoute(notification, user);
  } else if (isNotificationTypeToDo(notification.type)) {
    return getTodoNotificationRoute(notification, user);
  }
}

export function getTextNotificationsUnread(notificationsUnread) {
  let text = notificationsUnread;
  if (notificationsUnread >= 10) {
    text = '9+';
  }
  if (notificationsUnread >= 100) {
    text = '99+';
  }
  return text;
}

function getSocialNotificationsRoute(notification, user) {
  const { data } = notification;
  const state = {
    courseGuid: data?.course?.guid,
    guid: data?.course?.guid,
    lessonGuid: data?.message?.parentMessageData?.lesson_guid || data?.lesson?.guid,
    postGuid: data?.message?.parentMessageData?.lesson_item_guid || data?.message?.parent_guid || data?.message?.guid,
    unitGuid: data?.section?.guid,
    assessmentGuid: data?.lesson_item?.guid,
    contentGuid: data?.content?.guid,
    userGuid: data?.student?.guid,
    comment: '1',
  };

  const routeConfig = {
    [notificationsSubtypes.SOCIAL.ASSESSMENTCOMMENT]: ROUTES.LESSON,
    [notificationsSubtypes.SOCIAL.JOBCOMMENT]: isStudent(user) ? ROUTES.UNIT : ROUTES.RESULTS_ASSESSMENT,
  };

  const pathKey = routeConfig[notification.type] || ROUTES.COURSE;

  return { state, pathKey };
}

function getTodoNotificationRoute(notification, user) {
  const { data } = notification;
  console.log(notification);
  const baseState = {
    courseGuid: data?.course?.guid,
    guid: data?.course?.guid,
    lessonGuid: data?.lesson?.guid || data?.message?.parentMessageData?.lesson_guid,
    lessonItemGuid: data?.lesson_item?.guid,
    assessmentGuid: data?.content?.guid || data?.assesment?.guid,
    contentType: data?.content?.type_guid || data?.message?.content?.type_guid,
    contentGuid: data?.content?.guid,
    resourceType: data?.section?.type,
    section: data?.section?.guid,
    userGuid: data?.user?.guid,
    unitGuid: data?.section?.guid,
  };

  const routeConfig = {
    [notificationsSubtypes.TODO.DELIVERATCOMPLETE]: { pathKey: ROUTES.ASSESSMENT_RESULT, state: { ...baseState, userGuid: null } },
    [notificationsSubtypes.TODO.ALLDELIVER]: { pathKey: ROUTES.ASSESSMENT_RESULT, state: { ...baseState, userGuid: null } },
    [notificationsSubtypes.TODO.PUBLISHPENDING]: { pathKey: ROUTES.ASSESSMENT_RESULT, state: { ...baseState, userGuid: null } },
    [notificationsSubtypes.TODO.STUDENTDELIVER]: { pathKey: ROUTES.ASSESSMENT_RESULT, queryParams: { student: notification?.user?.guid } },
    [notificationsSubtypes.TODO.RESOURCE_ASSIGNED]: getResourceAssignedConfig(data),
    [notificationsSubtypes.TODO.RESOURCE_DELIVERED]: getResourceDeliveredConfig(data),
    [notificationsSubtypes.TODO.RESOURCE_EVALUATED]: getResourceEvaluatedConfig(data),
    [notificationsSubtypes.TODO.ASSIGNED]: getAssignedConfig(data),
    [notificationsSubtypes.TODO.EVALUATED]: getAssignedConfig(data),
    [notificationsSubtypes.TODO.RECORD_DELIVERED_LEMONADE]: getRecordDeliveredLemonadeConfig(data),
  };

  const defaultConfig = {
    pathKey: ROUTES.UNIT,
  };
  return { ...defaultConfig, ...routeConfig[notification.type], state: { ...baseState, ...routeConfig[notification.type]?.state } };
}

function getRecordDeliveredLemonadeConfig(data) {
  return {
    pathKey: ROUTES.SINGLE_ACTIVITY_RECORD,
    state: {
      courseGuid: data?.course?.guid,
      contentGuid: data?.content?.guid,
      referenceGuid: data?.content?.reference_id,
    },
    queryParams: {
      student: data?.student?.guid,
    },
  };
}

function getResourceAssignedConfig(data) {
  if (data?.section?.type === 'test' || data?.section?.type === 'activity') {
    return {
      pathKey: ROUTES.EVALUATION,
      state: {
        guid: data?.course?.guid,
        idResourcesSection: data?.section?.parent_guid,
        idResourcesGroup: data?.section?.guid,
        evaluationGuid: data?.item?.guid,
      },
    };
  }
  return {};
}

function getResourceDeliveredConfig(data) {
  if (data?.section?.type === 'test' || data?.section?.type === 'activity') {
    return {
      pathKey: ROUTES.EVALUATION_VIEW,
      state: {
        guid: data?.course?.guid,
        contentGuid: data?.content?.guid,
        evaluationGuid: data?.item?.guid,
        userGuid: data?.student?.guid,
      },
    };
  } else return {};
}

function getResourceEvaluatedConfig(data) {
  if (data?.section?.type === 'test') {
    return {
      pathKey: ROUTES.EVALUATION_RESULTS,
      queryParams: { notification: true },
      state: {
        courseGuid: data?.course?.guid,
        contentGuid: data?.content?.guid,
        evaluationGuid: data?.item?.guid,
      },
    };
  }
  return {};
}

function getAssignedConfig(data) {
  return {
    pathKey: ROUTES.CUSTOM_LESSON_UNIT,
    state: {
      courseGuid: data?.course?.guid,
      unitGuid: data?.section?.guid,
      lessonGuid: data?.lesson?.guid,
      contentGuid: data?.content?.type_guid === CONTENT_TYPES.MINT ? data?.lesson_item?.guid : data?.content?.guid,
    },
  };
}
